import { ActionTypeEntity, ModuleEntity } from "../interface";
import { checkActionAuthorization } from "../service/shared.service";

export interface TooltipPermissionRule {
    action: ActionTypeEntity;
    module: ModuleEntity;
}

export interface TooltipAccessRule {
    requires?: TooltipPermissionRule;
}

export type TooltipAccessConfig<T extends string> = Record<T, TooltipAccessRule>;
export type TooltipAccessMap<T extends string> = Record<T, boolean>;

export const resolveTooltipAccessMap = <T extends string>(
    config: TooltipAccessConfig<T>
): TooltipAccessMap<T> => {
    const entries = Object.entries(config) as [T, TooltipAccessRule][];

    return entries.reduce((acc, [tooltipId, rule]) => {
        if (!rule.requires) {
            acc[tooltipId] = true;
            return acc;
        }

        acc[tooltipId] = checkActionAuthorization(
            rule.requires.action,
            rule.requires.module
        );
        return acc;
    }, {} as TooltipAccessMap<T>);
};
